import { UI_COLOR_PRIMARY, UI_COLOR_WHITE } from '../../../../constants/uiColors'

export const REPORT_MOBILE_OUTLINED_ACTION_BUTTON_SX = {
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 14,
  lineHeight: 2,
  borderColor: UI_COLOR_PRIMARY,
  color: UI_COLOR_PRIMARY,
  fontWeight: 700,
  textTransform: 'none',
  gap: 0.5,
  '& .MuiButton-startIcon': {
    display: 'inherit',
    alignItems: 'center',
    marginRight: -1,
    marginLeft: 0
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: 18,
    verticalAlign: 'middle'
  },
  '&:hover': {
    borderColor: UI_COLOR_PRIMARY,
    bgcolor: UI_COLOR_PRIMARY,
    color: UI_COLOR_WHITE
  }
}
